import { defineStore } from "pinia"
const hostname = window.location.hostname

export const platformStore = defineStore("testStore", {
  state: () => ({
    sdkInitialized: false, //判断SDK是否初始化完成
    lang: localStorage.getItem("lang"),
    nowType: hostname.includes("qingcigame.com") ? "zhcn" : "global", //地址页面判断海外or国内
    backGameUrl: localStorage.getItem("backGameUrl") || "", //返回游戏地址
    maintenanceStatus: sessionStorage.getItem("maintenanceStatus") || "close", //维护状态
    fromGameSkuId: localStorage.getItem("fromGameSkuId") || "", //来自游戏直充的skuID
    gameId: Number(localStorage.getItem("gameId")) || "", // 游戏ID
    officialSettingId: Number(localStorage.getItem("officialSettingId")) || "", // 配置ID
    companyId: localStorage.getItem("companyId") || "", // 公司ID
    kfUrl: localStorage.getItem("kfUrl") || "", // 客服URL
    logo: localStorage.getItem("logo") || "", // logo图片
    webIcon: localStorage.getItem("webIcon") || "",
    access_token: localStorage.getItem("token") || "", // 账户token
    mobile: localStorage.getItem("mobile") || "", // 账户or手机号
    version: localStorage.getItem("version") || "", // 版本号
    availableLanguages:
      JSON.parse(localStorage.getItem("availableLanguages")) || "", // 可用语言列表
    tradeNo: localStorage.getItem("tradeNo") || "", // 充值订单号
    pointsNum: localStorage.getItem("pointsNum") || 0, //用户积分
    pointBatch: localStorage.getItem("pointBatch") || "", //积分商场批量兑换开启标识 0关闭 1开启
    currentSymbol: localStorage.getItem("currentSymbol"), //货币符号
    firstRuler: localStorage.getItem("firstRuler") || "", // 首次查看规则标识（活动抽奖用）
    popupType: localStorage.getItem("popupType") || 1, // 弹窗类型
    wechatOpenId: localStorage.getItem("openId") || "", // 微信openId
    loginTask: JSON.parse(localStorage.getItem("loginTask")) || {}, // 每日登录任务时间戳标记
    allRulersAgreed: localStorage.getItem("allRulersAgreed") || "", // 海外地址填写,协议全部同意标识
    localVersion: localStorage.getItem("localVersion") || "", // 本地版本号
    pwaRefresh: Number(localStorage.getItem("pwaRefresh")) || 1,
    passwordLoginList: {}, //免密登录信息
    isPwa: Number(localStorage.getItem("isPwa")) || 2, //是否为PWA1为是，2为否
    userId: localStorage.getItem("userId") || "", // 用户ID
    loginWay: localStorage.getItem("loginWay") || "account", // 登录方式
    chooseGameList: JSON.parse(localStorage.getItem("chooseGameList")) || {}, // 选择的游戏角色
    chargeActivityRedDot: false, // 限量累充活动红点
  }),
  actions: {
    // 设置访问token
    setAccessToken(token) {
      this.access_token = token
      if (token) {
        localStorage.setItem("token", token)
      } else localStorage.removeItem("token")
    },
    //设置当前语言
    changeLang(e) {
      this.lang = e
      if (e) {
        localStorage.setItem("lang", e)
      }
    },
    // 设置SDK初始化状态
    setSdkInitialized(status) {
      this.sdkInitialized = status
    },
    // 设置返回游戏地址
    setBackGameUrl(url) {
      this.backGameUrl = url
      if (url) {
        localStorage.setItem("backGameUrl", url)
        return
      }
      localStorage.removeItem("backGameUrl")
    },
    //设置来自游戏直充的skuID
    setFromGameSkuId(skuId) {
      this.fromGameSkuId = skuId
      if (skuId) {
        localStorage.setItem("fromGameSkuId", skuId)
        return
      }
      localStorage.removeItem("fromGameSkuId")
    },
    // 设置维护状态
    setMaintenanceStatus(status) {
      this.maintenanceStatus = status
      if (status) {
        sessionStorage.setItem("maintenanceStatus", status)
      }
    },
    // 设置游戏ID
    setGameId(gameId) {
      this.gameId = Number(gameId)
      if (gameId) {
        localStorage.setItem("gameId", gameId)
      } else localStorage.removeItem("gameId")
    },
    //设置配置ID
    setOfficialSettingId(officialSettingId) {
      this.officialSettingId = Number(officialSettingId)
      if (officialSettingId) {
        localStorage.setItem("officialSettingId", officialSettingId)
      } else localStorage.removeItem("officialSettingId")
    },
    //设置公司主体ID
    setCompanyId(companyId) {
      this.companyId = companyId
      if (companyId) {
        localStorage.setItem("companyId", companyId)
      } else {
        localStorage.removeItem("companyId")
      }
    },
    // 设置客服URL
    setKfUrl(kfUrl) {
      this.kfUrl = kfUrl
      if (kfUrl) {
        localStorage.setItem("kfUrl", kfUrl)
      } else localStorage.removeItem("kfUrl")
    },
    // 设置logo图片
    setLogo(logo) {
      this.logo = logo
      if (logo) {
        localStorage.setItem("logo", logo)
      }
    },
    // 设置手机号或者账号
    setMobile(mobile) {
      this.mobile = mobile
      if (mobile) {
        localStorage.setItem("mobile", mobile)
      } else localStorage.removeItem("mobile")
    },
    // 设置版本号
    setVersion(version) {
      this.version = version
      if (version) {
        localStorage.setItem("version", version)
      }
    },
    // 设置可用语言列表
    setAvailableLanguages(languages) {
      this.availableLanguages = languages
      if (languages) {
        localStorage.setItem("availableLanguages", JSON.stringify(languages))
      }
    },
    //设置积分商城批量兑换开启标识
    setPointBatch(pointBatch) {
      this.pointBatch = pointBatch
      localStorage.setItem("pointBatch", pointBatch || 0)
    },
    //设置货币符号
    setCurrentSymbol(symbol) {
      this.currentSymbol = symbol
      localStorage.setItem("currentSymbol", symbol)
    },
    //获取用户积分
    setPointsNum(num) {
      this.pointsNum = num || 0
      localStorage.setItem("pointsNum", num)
    },
    //设置充值订单号
    setTradeNo(tradeNo) {
      this.tradeNo = tradeNo
      if (tradeNo) {
        localStorage.setItem("tradeNo", tradeNo)
      } else localStorage.removeItem("tradeNo")
    },
    //设置首次查看规则标识
    setFirstRuler(status) {
      this.firstRuler = status
      if (status) {
        localStorage.setItem("firstRuler", status)
      } else localStorage.removeItem("firstRuler")
    },
    //设置弹窗类型
    setPopupType(type) {
      this.popupType = type || 1
      localStorage.setItem("popupType", type)
    },
    //设置微信openId
    setWechatOpenId(openId) {
      this.wechatOpenId = openId
      if (openId) {
        localStorage.setItem("openId", openId)
      } else localStorage.removeItem("openId")
    },
    // 设置每日登录任务时间戳标记
    setLoginTask(timestamp) {
      this.loginTask = timestamp
      if (timestamp) {
        localStorage.setItem("loginTask", JSON.stringify(timestamp))
      } else localStorage.removeItem("loginTask")
    },
    // 设置海外地址填写,协议全部同意标识
    setAllRulersAgreed(status) {
      this.allRulersAgreed = status
      if (status) {
        localStorage.setItem("allRulersAgreed", status)
      } else localStorage.removeItem("allRulersAgreed")
    },
    // 设置本地版本号
    setLocalVersion(version) {
      this.localVersion = version
      if (version) {
        localStorage.setItem("localVersion", version)
      } else localStorage.removeItem("localVersion")
    },
    // 设置PWA刷新标识
    setPwaRefresh(flag) {
      this.pwaRefresh = Number(flag)
      localStorage.setItem("pwaRefresh", flag)
    },
    //设置免密登录信息
    setPasswordLoginList(list) {
      this.passwordLoginList = list
    },
    //设置是否为PWA
    setIsPwa(isPwa) {
      this.isPwa = Number(isPwa)
      localStorage.setItem("isPwa", isPwa)
    },
    // 设置用户ID 
    setUserId(userId) {
      this.userId = userId
      if (userId) {
        localStorage.setItem("userId", userId)
      } else localStorage.removeItem("userId")
    },
    // 设置登录方式
    setLoginWay(loginWay) {
      this.loginWay = loginWay
      if (loginWay) {
        localStorage.setItem("loginWay", loginWay)
      } else localStorage.removeItem("loginWay")
    },
    // 设置选择的游戏角色
    setChooseGameList(chooseGameList) {
      this.chooseGameList = chooseGameList
      if (chooseGameList) {
        localStorage.setItem("chooseGameList", JSON.stringify(chooseGameList))
      } else localStorage.removeItem("chooseGameList")
    },
    //设置网页icon
    setWebIcon(icon) {
      this.webIcon = icon
      if (icon) {
        localStorage.setItem("webIcon", icon)
      } else localStorage.removeItem("webIcon")
    },
    setRedDot(isShow) {
      this.chargeActivityRedDot = isShow
    },
  }
})